import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {LIST, REQUEST_TO_CLOSE} from "./type";
export const getInvoiceList = (page=1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        `${Config.invoiceValidation.list}?page=${page}`
    );
    if (res) {
        const { data } = res;
        dispatch({ type: LIST, payload: data.response });
        return data;
    } else {
        return null;
    }
};

export const close = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.invoiceValidation.closeRequest}`
    );
    if (res) {
        const { data } = res;
        dispatch({ type: REQUEST_TO_CLOSE, payload: data.response });
        return data;
    } else {
        return null;
    }
};
